import React, { useEffect, useRef } from "react";
import { View, Image, Animated, StyleSheet, Easing } from "react-native";
import SuccessIcon from "../../../../../../assets/images/success-icon-arrow.png";
import RightArrowIcon from "../../../../../../assets/images/rightArrowIcon.png";

export default function AnimatedSuccessIcon() {
  const arrowX = useRef(new Animated.Value(-50)).current;
  const arrowOpacity = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    const timeout = setTimeout(() => {
      Animated.parallel([
        Animated.timing(arrowX, {
          toValue: 0, // move to center
          duration: 1000,
          easing: Easing.out(Easing.exp),
          useNativeDriver: true,
        }),
        Animated.timing(arrowOpacity, {
          toValue: 1,
          duration: 500,
          useNativeDriver: true,
        }),
      ]).start();
    }, 500);

    return () => clearTimeout(timeout);
  }, [arrowX, arrowOpacity]);

  return (
    <View style={styles.container}>
      {/* Background */}
      <Image
        source={SuccessIcon}
        style={styles.background}
        resizeMode="contain"
      />

      {/* Animated Arrow */}
      <Animated.Image
        source={RightArrowIcon}
        style={[
          styles.arrow,
          {
            opacity: arrowOpacity,
            transform: [{ translateX: arrowX }],
          },
        ]}
        resizeMode="contain"
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },
  background: {
    width: 80,
    height: 80,
  },
  arrow: {
    position: "absolute",
    width: 27.5,
    height: 25,
  },
});